// storybook-check-ignore
import React from 'react';

import { Box, Link, Text } from '@opendoor/bricks-next';
import { motion } from 'framer-motion';

import type { MegaNavSection } from '../../types';

interface MobileSubMenuSectionProps {
  section: MegaNavSection;
  parentName: string;
  navList?: any;
}

export const MobileSubMenuSection: React.FC<MobileSubMenuSectionProps> = ({
  section,
  parentName,
}) => {
  return (
    <Box marginBottom="$8x">
      <Text tag="h3" typography="$labelMedium" fontWeight="$medium" marginBottom="$8x">
        {section.title}
      </Text>
      <Box display="flex" flexDirection="column" gap="$4x">
        {section.links.map((link, linkIdx) => (
          <Box key={linkIdx} tag={motion.li as any} marginBottom="$8x">
            <Link
              href={link.href}
              textDecorationLine="none"
              aria-label={`Navigate to ${link.name}`}
              analyticsName={`cosmos-mega-nav-mobile-${parentName.toLowerCase()}-${link.name
                .toLowerCase()
                .replace(/\s+/g, '-')}`}
            >
              <Text
                tag="span"
                typography="$subheaderSmall"
                fontWeight="$medium"
                color="$contentPrimary"
                $smallerThanLG={{ typography: '$subheaderXsmall' }}
              >
                {link.name}
              </Text>
            </Link>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
